var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import PaymentService from '../../api/PaymentService';
import { Loading } from 'element-ui';
import Detail from "../accountcheck/Detail.vue";
import GLOBAL_VUE from '../../globalVue';
import { auth } from "../../helper/authDecorator";
import { toDetail } from "../../helper/util";
import { EBillType } from "../../enum/EBillType";
import { nameDict } from "../../constant/authCode";
import EAccountType from '../../enum/EAccountType';
import ImageView from "./component/ImageView.vue";
var EConfirmStatus;
(function (EConfirmStatus) {
    EConfirmStatus[EConfirmStatus["confirmNo"] = 1] = "confirmNo";
    EConfirmStatus[EConfirmStatus["confirmYes"] = 2] = "confirmYes";
    EConfirmStatus[EConfirmStatus["canceled"] = 5] = "canceled";
})(EConfirmStatus || (EConfirmStatus = {}));
var PaymentOrderDetail = (function (_super) {
    __extends(PaymentOrderDetail, _super);
    function PaymentOrderDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = [];
        _this.tableHeight = 350;
        _this.listType = '1';
        _this.rowId = null;
        _this.order = {
            account_date: [],
            purchase_order_order_list: []
        };
        _this.swiperShow = false;
        _this.imgs = [];
        _this.detailDialogTemplate = '';
        _this.eType = EAccountType;
        _this.confirmStatus = EConfirmStatus;
        _this.imageOpen = false;
        _this.imageArr = [];
        _this.title = '收款凭证';
        return _this;
    }
    PaymentOrderDetail.prototype.created = function () {
        this.service = PaymentService.getInstance();
        this.getPaymentDetail();
    };
    PaymentOrderDetail.prototype.reject = function () {
        var _this = this;
        this.$confirm("废弃后将不可修改，是否继续？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                order_ids: _this.order.order_id
            };
            _this.service.discardBill(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success("废弃成功");
                }
                _this.getPaymentDetail();
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PaymentOrderDetail.prototype.getPaymentDetail = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getPaymentDetail(Object.assign({ order_id: this.rowId }, pager)).then(function (res) {
            if (res.data.success) {
                var data = res.data.data;
                _this.data = data.order_list;
                _this.order = data;
                if (data.type == 1) {
                    _this.listType = '2';
                }
                _this.imageArr = data.payment_voucher;
                console.log('this.order', _this.order);
                _this.tableHeight = document.documentElement.clientHeight - 350 + (_this.order.order_status == _this.confirmStatus.confirmYes ? 40 : 0);
            }
            else {
                _this.$message.error(res.data.msg);
            }
            ;
            loadingInstance.close();
        }, function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    PaymentOrderDetail.prototype.pageChange = function (pager) {
        this.getPaymentDetail(pager);
    };
    PaymentOrderDetail.prototype.toLookImg = function (row) {
        var _this = this;
        this.$refs.carousel.setActiveItem(0);
        this.swiperShow = true;
        this.service.getOrderDocumentList({ order_id: row.order_id })
            .then(function (res) {
            var data = res.data;
            if (data.success && data.data.length) {
                if (data.data.length) {
                    var order_document = data.data;
                    _this.imgs = Array.isArray(order_document) ? order_document : [];
                }
                else {
                    _this.$message.error("暂无发票图片！");
                }
            }
            else {
                _this.$message.warning('暂无发票图片！');
            }
        }, function (err) { });
    };
    PaymentOrderDetail.prototype.confirm = function () {
        var _this = this;
        this.$confirm('确认后将不可修改，是否继续？', '提示', {
            customClass: 'confirm'
        }).then(function (res) {
            if (res) {
                var loadingInstance_1 = Loading.service({ fullscreen: true });
                _this.service.confirmBill({ order_id: _this.order.order_id }).then(function (res) {
                    if (res.data.code == 76) {
                        _this.$message.error(res.data.msg);
                        _this.getPaymentDetail();
                    }
                    else {
                        _this.$message.success(res.data.msg);
                        if (_this.opener && _this.opener.getPaymentList) {
                            _this.opener.getPaymentList();
                        }
                        GLOBAL_VUE.$emit("closeTab", _this);
                        window._czc.push(["_trackEvent", '付款单列表', '确认付款单']);
                    }
                }).catch(function (err) {
                    loadingInstance_1.close();
                    _this.$message.error(err.message || err.msg);
                });
            }
        }).catch(function () { });
    };
    PaymentOrderDetail.prototype.toAccountDetail = function (row) {
        GLOBAL_VUE.$emit("addTab", {
            component: Detail,
            title: '对账单详情',
            showExist: true,
            name: 'detail-account-check-' + row.order_id,
            cprops: {
                rowId: row.order_id
            }
        });
    };
    PaymentOrderDetail.prototype.toOrderDetail = function (row) {
        toDetail(EBillType.PurOrder, row.order_id, this);
    };
    PaymentOrderDetail.prototype.handleTypeChange = function (val) {
        console.log('this.listType', this.listType);
    };
    PaymentOrderDetail.prototype.watch_vorcher = function () {
        this.imageOpen = true;
    };
    PaymentOrderDetail.prototype.closeimg = function (type) {
        this.imageOpen = type;
    };
    PaymentOrderDetail = __decorate([
        auth(nameDict["客户付款单"]),
        Component({
            components: {
                HeaderItem: HeaderItem,
                'image-view': ImageView,
            }
        })
    ], PaymentOrderDetail);
    return PaymentOrderDetail;
}(Vue));
export default PaymentOrderDetail;
